import React from 'react';
import OfferApprove from '../../components/Offer/OfferApprove';
import OfferPixels from '../../components/Offer/OfferPixels';
import OfferPostClick from '../../components/Offer/OfferPostClick';
import OfferSources from '../../components/Offer/OfferSources';
import Card from '../../components/Card/Card';

const OfferAdditionalInfo = ({ offer, countries, sources, handleRequestOfferAccess, prefix }) => (
  <div className="offer-conditions offer-card">
    <Card>
      <p className="offer-conditions-title">Условия</p>
      <div className="offer-conditions-top">
        {offer.stats && offer.stats.length > 0 && !offer.modifies.g && !offer.modifies.d && (
          <OfferApprove stats={offer.stats} />
        )}
        {offer.expire !== undefined && <OfferPostClick hold={offer.expire} />}
      </div>
      {offer.pixels && offer.pixels.length > 0 && (
        <OfferPixels
          pixels={offer.pixels}
          offerId={offer.id}
          isGambling={offer.modifies.g}
          isCdn={offer.modifies.is_cdn}
          coins={offer.modifies.coins}
          countries={countries}
          offer_geo={offer.offer_geo}
          geos={offer.geo}
        />
      )}
      {offer.sources && offer.sources.length > 0 && (
        <OfferSources
          sources={sources}
          selected={offer.sources}
          invert={offer.sources_inversion}
          prefix={prefix}
        />
      )}

      {/* {offer.id && <OfferSupportHours offerId={offer.id} /> 
      {offer.top_bundle && (
        <OfferTopLink
          item={offer.top_bundle}
          offer={offer}
          onClick={handleRequestOfferAccess}
          inOfferPage
        />
      )}
      {offer.files && offer.files.length > 0 && <OfferFiles files={offer.files} />} 
      {offer.forbiddenGeo && offer.forbiddenGeo.length > 0 && !offer.modifies.is_cdn && (
       <OfferForbiddenGeoList countries={offer.forbiddenGeo} />
      )}  */}
    </Card>
  </div>
);

export default OfferAdditionalInfo;
